// Module
var code = "<div class=\"items\"></div> <a class=\"add-item\" href=\"#\"> <span class=\"striimline-icon add\"></span> {{editor.options.add_text}} </a> ";
// Exports
export default code;